import type { Href } from "expo-router";
import { router } from "expo-router";
import { ArrowLeft2 } from "iconsax-react-nativejs";
import { cssInterop } from "nativewind";
import { useTranslation } from "react-i18next";
import { Pressable, Text, ViewStyle } from "react-native";

const StyledArrowLeft2 = cssInterop(ArrowLeft2, {
  className: {
    target: "style",
    nativeStyleToProp: {
      color: true,
    },
  },
});

type BackNavigationButtonProps = Readonly<{
  label?: string;
  labelClassName?: string;
  iconSize?: number;
  iconClassName?: string;
  to?: Href;
  containerStyle?: ViewStyle;
  onPress?: () => void;
}>;

export default function BackNavigationButton({
  label,
  labelClassName,
  iconSize = 16,
  iconClassName,
  to,
  containerStyle,
  onPress,
}: BackNavigationButtonProps) {
  const { t } = useTranslation();

  const handlePress = () => {
    if (onPress) {
      onPress();
    } else if (to) {
      router.push(to);
    } else {
      router.back();
    }
  };

  return (
    <Pressable
      style={containerStyle}
      className="flex-row items-center gap-1 mb-6 px-2 py-1 active:opacity-70 hover:bg-ash-3 hover:rounded-lg"
      onPress={handlePress}
      hitSlop={8}
    >
      <StyledArrowLeft2 size={iconSize} className={iconClassName ?? "text-onyx"} />
      <Text
        className={`text-sm font-medium text-onyx ${labelClassName ?? ""}`}
        style={{ lineHeight: iconSize }}
      >
        {label ?? t("BTN_BACK")}
      </Text>
    </Pressable>
  );
}
